import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Car icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Car } from '@sravni/design-system-icons'
 *
 * <Car />
 * ```
 */
var Car = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Car", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m18.833 7.5-2.183.833M4.358 8.333 2.167 7.5M15.708 11.666h-2.083M7.375 11.666H5.292M16.65 8.333l-.7-3.343a2.084 2.084 0 0 0-2.04-1.657H7.177c-.968 0-1.809.667-2.029 1.61l-.792 3.39M3.208 16.667h1.875c.69 0 1.25-.56 1.25-1.25v-.834h8.334v.834c0 .69.56 1.25 1.25 1.25h1.875c.575 0 1.041-.467 1.041-1.042v-4.792a2.5 2.5 0 0 0-2.5-2.5H4.667a2.5 2.5 0 0 0-2.5 2.5v4.792c0 .575.466 1.042 1.041 1.042Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Car };
//# sourceMappingURL=Car.js.map
